import { getEnvironment } from 'config/configure';
import { TOKEN_KEYS } from './constants';
import storage from './cookie-storage';

function getKey() {
  const env = getEnvironment();
  return TOKEN_KEYS[env];
}

/**
 * Delete token from storage
 */
export function clearToken() {
  storage.clearToken(getKey());
}

/**
 * Add or remove token from storage.
 *
 * If `token` is a string, it will get stored. If `token` is undefined, the token
 * in storage will be cleared.
 */
export function storeToken(token: string | undefined): void {
  if (token) {
    storage.setToken(getKey(), token);
  } else {
    storage.clearToken(getKey());
  }
}

/**
 * Retrieve token from storage
 */
export function getToken(): string | undefined {
  return storage.getToken(getKey());
}

const sso = {
  clearToken,
  getToken,
  storeToken,
};

export default sso;
